import * as types from './actionTypes';
import {
  getVerificationsFromPayload,
  setDashboardModuleStatus
} from './operations';
import {
  REFRESH_PLAID_BALANCE,
  LINK_PLAID
} from '../components/Plaid/ducks/actionTypes';

const initialState = {
  status: setDashboardModuleStatus(),
  hasLoaded: false,
  verifications: {
    canAttachPlaid: false,
    fundsAreVerified: false,
    plaidIsValid: false,
    plaidAchMismatch: false,
    plaidInvalidIdentity: false,
    accountNumberMask: '',
    customerIsGreen: false
  },
  orderOptions: {
    isPlaidCustomer: false
  },
  achSubscription: {
    accountLastFour: ''
  }
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case `${types.VERIFICATIONS_FETCH}_LOADING`:
      return {
        ...state
      };

    case `${types.VERIFICATIONS_FETCH}_SUCCESS`: {
      if (!payload) {
        return {
          ...state,
          ...payload
        };
      }
      const verifications = getVerificationsFromPayload(payload);

      let overallPanelStatus = {};

      if (verifications.status?.isComplete) {
        overallPanelStatus = setDashboardModuleStatus({ isComplete: true });
      } else if (verifications.status?.actionIsRequired) {
        overallPanelStatus = setDashboardModuleStatus({
          actionIsRequired: true
        });
      } else {
        overallPanelStatus = setDashboardModuleStatus({ isComplete: false });
      }

      return {
        ...state,
        status: setDashboardModuleStatus(overallPanelStatus),
        verifications: {
          ...payload,
          ...verifications
        }
      };
    }

    case `${types.VERIFICATIONS_FETCH}_ERROR`:
      return {
        ...state,
        ...payload
      };

    case `${REFRESH_PLAID_BALANCE}_SUCCESS`:
      return {
        ...state,
        verifications: {
          ...state.verifications,
          fundsVerification: {
            ...state.verifications.fundsVerification,
            ...payload
          }
        }
      };

    case `${LINK_PLAID}_SUCCESS`: {
      const {
        isValid = false,
        plaidAchMismatch = true,
        plaidIdentityValidForFunds = false,
        fundsVerification = {}
      } = payload;

      if (!isValid) {
        return {
          ...state,
          verifications: {
            ...state.verifications,
            fundsVerification: {
              ...state.verifications.fundsVerification,
              plaidContainsAchAccount: !plaidAchMismatch,
              plaidIdentityValidForFunds
            }
          }
        };
      }

      return {
        ...state,
        verifications: {
          ...state.verifications,
          fundsVerification: {
            ...state.verifications.fundsVerification,
            ...fundsVerification
          }
        }
      };
    }

    case `${types.ORDER_OPTIONS_FETCH}_LOADING`:
      return {
        ...state
      };

    case `${types.ORDER_OPTIONS_FETCH}_SUCCESS`:
      return {
        ...state,
        orderOptions: payload
      };

    case `${types.PAYMENT_COLLECTIONS_FETCH}_LOADING`:
      return {
        ...state
      };

    case `${types.PAYMENT_COLLECTIONS_FETCH}_SUCCESS`:
      return {
        ...state,
        achSubscription: {
          accountLastFour: payload.ach?.accountLastFour
        },
        verifications: {
          ...state.verifications,
          accountLastFour: payload.ach?.accountLastFour
        }
      };

    case `${types.PAYMENT_COLLECTIONS_FETCH}_ERROR`:
      return {
        ...state
      };

    default:
      return state;
  }
};

export default reducer;
